export default __webpack_public_path__ + "static/media/WanDirection_instructions.e6401da5.png";